import { useTranslation } from "react-i18next";

export default function EuFundSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-secondary/50" data-testid="eu-fund-section">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 mb-12">
          <div className="space-y-6">
            <div className="border-l-2 border-primary pl-4">
              <p className="font-bold text-foreground" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("euFund.duration")}</p>
              <p className="text-muted-foreground">{t("euFund.durationValue")}</p>
            </div>
            <div className="border-l-2 border-primary pl-4">
              <p className="font-bold text-foreground" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("euFund.budget")}</p>
              <p className="text-muted-foreground">{t("euFund.budgetValue")}</p>
            </div>
            <div className="border-l-2 border-primary pl-4">
              <p className="font-bold text-foreground" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("euFund.euFunding")}</p>
              <p className="text-muted-foreground">{t("euFund.euFundingValue")}</p>
            </div>
          </div>
          <div className="lg:col-span-2">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("euFund.title")}</h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              <span className="font-semibold text-foreground">{t("euFund.goalLabel")}</span> {t("euFund.goalText")}
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <p className="text-base md:text-lg text-foreground/80 leading-relaxed mb-10">{t("euFund.projectLabel")}</p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            <img src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/q4l6t18f_LV%20L%C5%92dzfinans%E2%80%B0%20Eiropas%20Savien%C5%92ba_POS.jpg" alt="Līdzfinansē Eiropas Savienība" className="h-14 md:h-20 w-auto object-contain" loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/9tgc0wn7_NAP_logo_ar_nosaukumu_JPEG_H1200px_lv.jpg" alt="Nacionālais attīstības plāns 2027" className="h-14 md:h-20 w-auto object-contain" loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/xlwmq9we_altum_attistiba_logo_bez_teksta.png" alt="ALTUM Attīstības finanšu institūcija" className="h-14 md:h-20 w-auto object-contain" loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/4023w1b4_pilnkrasu_rgb-51-copy.jpg" alt="Labklājības ministrija" className="h-14 md:h-20 w-auto object-contain" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
